import React, {PureComponent} from 'react';
import FontAwesome from 'react-fontawesome';
import Table from '../../../components/Table';
import {Col, Button, Row, Card, CardBody,Badge,ButtonGroup} from 'reactstrap';
import * as http from '../../../modules/http';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';
import IconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';
import * as TextManager from "../../../modules/languages/TextManager";


const actionsStyles = theme => ({
    root: {
        flexShrink: 0,
        color: theme.palette.text.secondary,
        marginLeft: theme.spacing.unit * 2.5,
    },
});

class TablePaginationActions extends React.Component {
    handleFirstPageButtonClick = event => {
        this.props.onChangePage(event, 0);
    };

    handleBackButtonClick = event => {
        this.props.onChangePage(event, this.props.page - 1);
    };

    handleNextButtonClick = event => {
        this.props.onChangePage(event, this.props.page + 1);
    };

    handleLastPageButtonClick = event => {
        this.props.onChangePage(
            event,
            Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1),
        );
    };

    render() {
        const { classes, count, page, rowsPerPage, theme } = this.props;

        return (
            <div className={classes.root}>
                <IconButton
                    onClick={this.handleFirstPageButtonClick}
                    disabled={page === 0}
                    aria-label="First Page"
                >
                    {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
                </IconButton>
                <IconButton
                    onClick={this.handleBackButtonClick}
                    disabled={page === 0}
                    aria-label="Previous Page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
                </IconButton>
                <IconButton
                    onClick={this.handleNextButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Next Page"
                >
                    {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
                </IconButton>
                <IconButton
                    onClick={this.handleLastPageButtonClick}
                    disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                    aria-label="Last Page"
                >
                    {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
                </IconButton>
            </div>
        );
    }
}

TablePaginationActions.propTypes = {
    classes: PropTypes.object.isRequired,
    count: PropTypes.number.isRequired,
    onChangePage: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    theme: PropTypes.object.isRequired,
};

const TablePaginationActionsWrapped = withStyles(actionsStyles, { withTheme: true })(
    TablePaginationActions,
);


const CustomPagination = withStyles(theme => ({
    root: {
        float: 'left'
    },
    '@media screen and (max-width: 480px)': {
        root: {
            //backgroundColor: theme.palette.common.black,
            marginLeft: '-50px'
        }
    }

}))(TablePagination);


class StoreOrdersTable extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            windowType: 0,
            selectedID: '0',
            saving: false,
            error: false,
            page: 0,
            rowsPerPage: 20
        };
    }

    handleChangePage = (event, page) => {
        this.setState({page});
    };

    handleChangeRowsPerPage = event => {
        this.setState({rowsPerPage: event.target.value});
    };

    getStatus = (status) => {
        if (status === 0)
            return TextManager.getCurrentTextResource().Text.new;
        else
            return TextManager.getCurrentTextResource().Text.active;
    };

    getStatusColor = (status) => {
        if (status === 0)
            return "warning";
        else
            return "primary";
    };

    getRow(task, index) {

        return (

            <React.Fragment key={task.id}>

                <tr key={task.id} onClick={() => this.editTask(task)}>

                    <td>
                        <Badge color={this.getStatusColor(task.status)}>{this.getStatus(task.status)}</Badge>
                    </td>
                    <td>{task.updateDay}</td>
                    <td>{task.orders}</td>
                    <td>{task.day}</td>
                </tr>

            </React.Fragment>
        );
    }

    render() {

        const {rowsPerPage, page} = this.state;

        //Build the And add the selected row
        let rows = [];

        rows = this.props.data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((task, index) =>
            this.getRow(task, index)
        );


        return (
            <Col md={12} xl={12} lg={12} xs={12}>
                <Card>
                    <CardBody>
                        <span>
                            <Table responsive className='table-hover table--bordered'>
                                <thead>
                                <tr>
                                    <th>סטאטוס</th>
                                    <th>תאריך טיפול</th>
                                    <th>פרטי הזמנה</th>
                                    <th>תאריך הזמנה</th>
                                </tr>
                                </thead>
                                <tbody>
                                {rows}
                                </tbody>
                            </Table>
                            <CustomPagination
                                labelRowsPerPage='' //{TextManager.getCurrentTextResource().Utils.rowsPerPage}
                                rowsPerPageOptions={[5, 10, 20]}
                                component="div"
                                count={this.props.data.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                backIconButtonProps={{
                                    'aria-label': 'Previous Page',
                                }}
                                nextIconButtonProps={{
                                    'aria-label': 'Next Page',
                                }}
                                onChangePage={this.handleChangePage}
                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                ActionsComponent={TablePaginationActionsWrapped}
                            />
                        </span>
                    </CardBody>
                </Card>
            </Col>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        status: state.tasks.status,
        userData: state.userData,
        utilsData: state.utilsData,
    };
};

export default withRouter(connect(mapStateToProps)(StoreOrdersTable))